import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/code/giftWall',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-GiftWall-index" */ '~/pages/r_code/GiftWall/pages/index'
        )
    ),
  },
  // 标题勋章
  {
    path: '/code/giftWall/rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-GiftWall-rank" */ '~/pages/r_code/GiftWall/pages/rank'
        )
    ),
  },
] as RouteConfig[]
